<template>
  <div id="statistics">
    <div id="top" class="flex">
      <div class="flex-twice">
        <div class="" style="">
          <p class="p1 flex align-center">用户数据</p>
          <div class="flex justify-between">
            <div class="flex flex-direction justify-between tip">
              <p class="p2"><span class="yuan"></span>当前在线用户量</p>
              <p class="p3">{{formData.online_now}} <span style="font-size: 14px;">人</span></p>
            </div>
            <div class="flex flex-direction justify-between tip">
              <p class="p2"><span class="yuan"></span>今日在线用户量</p>
              <div class="flex align-center justify-between">
                <p class="p3">{{formData.online_today}} <span style="font-size: 14px;">人</span></p>
                <p style="color: #9CA1C3;font-size: 14px;">昨日
                  <i v-show="formData.online_yestoday>formData.online_today" class="el-icon-caret-bottom isdown">
                    {{Math.abs((formData.online_yestoday-formData.online_today))}}
                  </i>
                  <i v-show="formData.online_yestoday<formData.online_today" class="el-icon-caret-top isup">
                    {{Math.abs((formData.online_yestoday-formData.online_today))}}
                  </i>
                  <span v-show="formData.online_yestoday==formData.online_today" style="color:#FF832A;font-size: 14px;">
                    <span style="color: #FF832A;font-size: 16px;font-weight: 700;"> - </span>持平
                  </span>
                </p>
              </div>
              <!-- Math.abs -->
            </div>
            <div class="flex flex-direction justify-between tip">
              <p class="p2"><span class="yuan"></span>今日新增用户量</p>
              <div class="flex align-center justify-between">
                <p class="p3">{{formData.new_user_today}} <span style="font-size: 14px;">人</span></p>
                <p style="color: #9CA1C3;font-size: 14px;">昨日
                  <i v-show="formData.new_user_yestoday>formData.new_user_today" class="el-icon-caret-bottom isdown">
                    {{Math.abs((formData.new_user_yestoday-formData.new_user_today))}}
                  </i>
                  <i v-show="formData.new_user_yestoday<formData.new_user_today" class="el-icon-caret-top isup">
                    {{Math.abs((formData.new_user_yestoday-formData.new_user_today))}}
                  </i>
                  <span v-show="formData.new_user_yestoday==formData.new_user_today" style="color:#FF832A;font-size: 14px;">
                    <span style="color: #FF832A;font-size: 16px;font-weight: 700;"> - </span>持平
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="" style="margin-top: 24px;">
          <p class="p1 flex align-center">软件数据</p>
          <div class="flex justify-between" style="margin-bottom: 24px;">
            <div class="flex flex-direction justify-between tip">
              <p class="p2"><span class="yuan"></span>今日算价次数</p>
              <div class="flex align-center justify-between">
                <p class="p3">{{formData.price_count_today}}<span style="font-size: 14px;">次</span></p>
                <p style="color: #9CA1C3;font-size: 14px;">昨日
                  <i v-show="formData.price_count_yestoday>formData.price_count_today" class="el-icon-caret-bottom isdown">
                    {{Math.abs((formData.price_count_yestoday-formData.price_count_today))}}
                  </i>
                  <i v-show="formData.price_count_yestoday<formData.price_count_today" class="el-icon-caret-top isup">
                    {{Math.abs((formData.price_count_yestoday-formData.price_count_today))}}
                  </i>
                  <span v-show="formData.price_count_yestoday==formData.price_count_today" style="color:#FF832A;font-size: 14px;">
                    <span style="color: #FF832A;font-size: 16px;font-weight: 700;"> - </span>持平
                  </span>
                </p>
              </div>

            </div>
            <div class="flex flex-direction justify-between tip">
              <p class="p2"><span class="yuan"></span>今日软件启动次数</p>
              <div class="flex align-center justify-between">
                <p class="p3">{{formData.open_today}}<span style="font-size: 14px;">次</span></p>
                <p style="color: #9CA1C3;font-size: 14px;">昨日
                  <i v-show="formData.open_yestoday>formData.open_today" class="el-icon-caret-bottom isdown">
                    {{Math.abs((formData.open_yestoday-formData.open_today))}}
                  </i>
                  <i v-show="formData.open_yestoday<formData.open_today" class="el-icon-caret-top isup">
                    {{Math.abs((formData.open_yestoday-formData.open_today))}}
                  </i>
                  <span v-show="formData.open_yestoday==formData.open_today" style="color:#FF832A;font-size: 14px;">
                    <span style="color: #FF832A;font-size: 16px;font-weight: 700;"> - </span>持平
                  </span>
                </p>
              </div>

            </div>
            <div class="flex flex-direction justify-between tip">
              <p class="p2"><span class="yuan"></span>今日提交反馈次数</p>
              <div class="flex justify-between align-center">
                <p class="p3">{{formData.fb_today}}<span style="font-size: 14px;">次</span></p>
                <p style="color: #9CA1C3;font-size: 14px;">昨日
                  <i v-show="formData.fb_yestoday>formData.fb_today" class="el-icon-caret-bottom isdown">
                    {{Math.abs((formData.fb_yestoday-formData.fb_today))}}
                  </i>
                  <i v-show="formData.fb_yestoday<formData.fb_today" class="el-icon-caret-top isup">
                    {{Math.abs((formData.fb_yestoday-formData.fb_today))}}
                  </i>
                  <span v-show="formData.fb_yestoday==formData.fb_today" style="color:#FF832A;font-size: 14px;">
                    <span style="color: #FF832A;font-size: 16px;font-weight: 700;"> - </span>持平
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="" style="width: 454px;height: 280px;border-radius: 6px;">
        <p class="p1 flex align-center">卡密数据</p>
        <div class=""
          style="width: 454px;height: 254px;background-color: #FFFFFF;padding: 16px;box-sizing: border-box;">
          <div class="flex" style="margin-top: 18px;">
            <div class="flex flex-direction align-center flex-sub">
              <p style="color: #333333;font-size: 24px;margin-bottom: 16px;">{{formData.code_count}}</p>
              <p style="color: #ACAEBB;font-size: 14px;">卡密库存量</p>
            </div>
            <div class="flex flex-direction align-center flex-sub">
              <p style="color: #333333;font-size: 24px;margin-bottom: 16px;">{{formData.code_count_use}}</p>
              <p style="color: #ACAEBB;font-size: 14px;">已使用卡密</p>
            </div>
          </div>

          <div class="flex flex-direction justify-between"
            style="background-color: #F5F6F7;height: 101px;margin-top: 34px;border-radius: 4px;padding: 16px;box-sizing: border-box;">
            <p style="color: #ACAEBB;font-size: 14px;"><span class="yuan"></span>今日生成激活码数</p>
            <div class="flex align-center justify-between">
              <p style="color: #333333;font-size: 24px;">{{formData.code_make_today}} <span style="color: #333333;font-size: 14px;">次</span></p>
              <div class="flex align-center justify-between">
                  <i v-show="formData.code_make_yestoday>formData.code_make_today" class="el-icon-caret-bottom isdown">
                    {{Math.abs((formData.code_make_yestoday-formData.code_make_today))}}
                  </i>
                  <i v-show="formData.code_make_yestoday<formData.code_make_today" class="el-icon-caret-top isup">
                    {{Math.abs((formData.code_make_yestoday-formData.code_make_today))}}
                  </i>
                  <span v-show="formData.code_make_yestoday==formData.code_make_today" style="color:#FF832A;font-size: 14px;">
                    <span style="color: #FF832A;font-size: 16px;font-weight: 700;"> - </span>持平
                  </span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="bottom" class="flex" style="padding-bottom: 30px;">
      <div class="flex-sub" style="margin-right: 24px;">
        <p class="p1">卡密使用量数据</p>
        <div class="" style="background-color: #FFFFFF;padding: 16px;border-radius: 6px;text-align: left;">
          <el-select disabled v-model="time" placeholder="服务时长永久">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <!-- 环状图 -->
          <div id="myChart_jmnl" style="width: 100%; height: 280px"></div>

          <div class="" style="background-color: #F5F6F7;padding: 16px;margin-top: 20px;">
            <p class="p1">今日数据</p>
            <div class="">
              <p class="flex justify-between align-center">
                <span class="span_">今日使用量</span>
                <span style="color: #1BADE8;">{{formData.code_count_use_today}}次</span>
              </p>
              <p class="flex justify-between align-center" style="margin: 8px 0;">
                <span class="span_">环比（昨日）</span>
                <span style="color: #9CA1C3;font-size: 14px;">
                  <i v-show="formData.code_count_use_yestoday>formData.code_count_use_today" class="el-icon-caret-bottom isdown">
                    {{Math.abs((formData.code_count_use_yestoday-formData.code_count_use_today))}}
                  </i>
                  <i v-show="formData.code_count_use_yestoday<formData.code_count_use_today" class="el-icon-caret-top isup">
                    {{Math.abs((formData.code_count_use_yestoday-formData.code_count_use_today))}}
                  </i>
                  <span v-show="formData.code_count_use_yestoday==formData.code_count_use_today" style="color:#FF832A;font-size: 14px;">
                    <span style="color: #FF832A;font-size: 16px;font-weight: 700;"></span>持平
                  </span>
                </span>
              </p>
              <p class="flex justify-between align-center">
                <span class="span_">昨日使用量</span>
                <span class="span_">{{formData.code_count_use_yestoday}}次</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 地图 -->
      <div class="flex-twice">
        <p class="p1">用户IP省市分布范围</p>
        <div class="" style="background-color: #FFFFFF;padding: 16px;border-radius: 6px;box-sizing: border-box;">
          <p style="font-size: 24px;color: #1BADE8;text-align: center;margin-bottom: 26px;font-weight: 700;">区域分配总数: {{allTip}}
          </p>
          <div class="wrapper" style="padding: 10px;">
            <div class="map-container" ref="myEchart" style='width:100%;height:400px;margin: 0 auto;'></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  const echarts = require("echarts")
  import '../../node_modules/echarts/map/js/china.js'
  export default {
    name: 'Home',
    created() {
      this.getUserFrom()
    },
    data() {
      return {
        /* 获取用户报表请求参数 */
        userFormObj:{
          act:'userForm',
          token:localStorage.getItem('token')
        },
        /* 接收渲染页面数据 */
        formData:{},
        smalltip:[],

		/* 地图小点数据 */
		mapTip:{},

        /************************************* */
        id: 2,
        options: [],
        time: '', //服务时长
        echartsOption: {
          title:{
            text:'卡密使用情况',
            left:'center',
            top:'45%',
            textStyle:{

            },
          },
          tooltip: {
            trigger: "item",
            show: true,
            formatter: function(param) {
              //自定义修改鼠标悬浮提示框展示内容及内容文字颜色
              return `${param.name}<br/><span style="color:${param.color}"> ${param.value} 个</span>`;
            },
          },
          legend: {
            top: "2%", //图例组件离容器上侧的距离。
            left: "center", //图例组件离容器左侧的距离。
            show: false,
          },
          series: [{
            name: "",
            type: "pie",
            radius: ["50%", "80%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            //控制鼠标悬浮时圆环中间显示相应小标题
            emphasis: {
              label: {
                show: false,
                fontSize: "24",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value:'',
                name:'今日卡密使用量'
              },
              {
                value:'',
                name:'昨日卡密使用量'
              }
            ], //              // data: [],/ceshiList[i - 1].data
          }],
          //设置圆环中文字
          graphic: [{
            type: "text",
            left: "center",
            top: "center",
            style: {
              textAlign: "center",
              fill: "#3670FF",
              fontSize: 18,
            },
          }],
        },

        /* 地图 */
        option2:{
          series: [
            {
              type: "map",
              map: "china",
              roam: false,
              zoom: 1.23,
              center: [105, 36],
              tooltip: {
                show: false,
              },
              // geoIndex: 1,
              // aspectScale: 0.75, //长宽比
              showLegendSymbol: false, // 存在legend时显示
              label: {
                normal: {
                  show: false,
                },
                emphasis: {
                  show: true
                }
              },
              itemStyle: {
                normal: {
                  areaColor: "#DDF1FF",
                  borderColor: "#AAD1EC", //地图内线条的颜色（地图整体边框，省份边框）
                  borderWidth: 0.5
                },
                emphasis: {
                  areaColor: "#68C1FF",//鼠标悬浮，对应省份显示的颜色
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  shadowBlur: 5,
                  borderWidth: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            },
            {
              name: "",
              type: "scatter",
              coordinateSystem: "geo",
              data: [], //****************************d所需数据
              // symbolSize: 5,
              symbolSize: function(val) {
                // console.log(val[2])
                let num
                if (val[2] != '0') {
                  num = 5
                }
                return num || 0;
              },
              symbol: "circle",
              // 把散点用图片代替在这里设置
              // symbol:'image://'+this.img,
              // 设置图片大小
              // symbolSize:[30, 20],
              hoverSymbolSize: 10,
              tooltip: {
                show: true,
                formatter(params, ticket, callback) {
                  // params.data 就是series配置项中的data数据遍历
                  let localValue,
                    perf,
                    downloadSpeep,
                    usability,
                    point
                  if (params.data) {
                    localValue = params.data.value
                    perf = params.data.perf
                    downloadSpeep = params.data.downloadSpeep
                    usability = params.data.usability
                    point = params.data.point
                  } else { // 为了防止没有定义数据的时候报错写的
                    localValue = 0
                    perf = 0
                    downloadSpeep = 0
                    usability = 0
                    point = 0
                  }
                  let htmlStr = `
                      <div style='font-size:18px;'> ${params.name}</div><br/>
                      <p style='text-align:left;margin-top:-10px;'>
                        区域IP地址量：${params.value[2]}<br/>
                      </p>
                    `
                  return htmlStr
                }
              },
              encode: {
                value: 2
              },
              label: {
                formatter: "{b}",
                position: "right",
                show: false
              },
              itemStyle: {
                color:"red"
              },
              emphasis: {
                label: {
                  show: false
                }
              }
            },
          ]
        },
        allTip:'',
      }
    },
    watch: {
      widthOrHight() { // 监听页面宽度或者高度
        let that = this;
        setTimeout(function() {
          // that.initPage();  // 监听到页面size发生变化，则重新初始化div的宽高
          const index = 10; //随便定义一个随机数
          that.myChart.setOption(that.echartsOption)
          that.myEchart = echarts.init(that.$refs.myEchart)
          that.myEchart.setOption(that.option1)
        }, 400)
      }
    },
    methods: {
      /* 获取用户报表 */
      getUserFrom(){
        console.log('1')
        this.$api.login.accInfo(this.userFormObj).then(res=>{
          console.log('用户报表：',res)
          if(res.code=="1"){
            this.formData=res.data
            this.echartsOption.series[0].data[0].value=this.formData.code_count_use_today
            this.echartsOption.series[0].data[1].value=this.formData.code_count_use_yestoday
            this.mapTip=res.data.user_area
            let data = [];
            for (let key in this.mapTip) {
              data.push({
                name: key,
                value: this.mapTip[key]
              })
            }
            this.option2.series[1].data=data
            this.myEchart.setOption(this.option2);
            this.myChart.setOption(this.echartsOption)
            /* 计算ip总量 */
            let arr=[]
            for (let item in res.data.user_area) {
                console.log(res.data.user_area[item][2])
                arr.push(res.data.user_area[item][2])
            }
            console.log(arr)
            this.allTip=arr.reduce(function (accumulator, currentValue) {
              return accumulator + currentValue;
            }, 0)
            console.log(this.allTip)
          }
        })
      },

      // ******************************************
      // dealWithData() {
      //   var geoCoordMap = {
      //     大庆: [125.03, 46.58, 3],
      //     海门: [121.15, 31.89, 17],
      //     舟山: [122.207216, 29.985295, 3],
      //     威海: [122.1, 37.5, 3],
      //     承德: [117.93, 40.97, 15],
      //     厦门: [118.1, 24.46, 3],
      //     汕尾: [115.375279, 22.786211, 9],
      //     潮州: [116.63, 23.68, 3],
      //     丹东: [124.37, 40.13, 3],
      //     太仓: [121.1, 31.45, 3],
      //     曲靖: [103.79, 25.51, 12],
      //     烟台: [121.39, 37.52, 3],
      //     福州: [119.3, 26.08, 3],
      //     芜湖: [118.38, 31.33, 25],
      //     合肥: [117.27, 31.86, 0],
      //   }
      //   var data = [];
      //   console.log(this.mapTip)
      //   for (var key in this.mapTip) {
      //     data.push({
      //       name: key,
      //       value: this.mapTip[key]
      //     });
      //   }
      //   return data;
      // }
    },
    mounted() {
      this.myChart = echarts.init(document.getElementById("myChart_jmnl")); // 初始化echarts, theme为light
      this.myChart.setOption(this.echartsOption);
      this.myChart.on('mouseover', (params) => {
        this.echartsOption.title.text=''
        this.myChart.setOption(this.echartsOption);
        let num = this.formData.code_count
        this.currName = params.name;
          // console.log(params)
          let op = this.myChart.getOption();
          let _label = {
              normal:{
                  show: true,
                  position: 'center',
                  formatter: [
                      `{a|${params.value}} / {c|${num}}`,
                      `{b|${params.name}}`
                  ].join('\n'),
                  rich: {
                      a: {
                          color:'#3551DF',
                          fontSize: 18,
                          lineHeight: 30
                      },
                      b: {
                          color:'#ACAEBB',
                          fontSize: 18,
                          // foneWeight:'bold',
                      },
                      c:{
                        color:'#B0B6DC',
                        fontSize:18,
                        lineHeight: 30
                      }

                  }
              }
          }
          // console.log(_label)
          if(params.seriesIndex === 1){
              _label.normal.formatter = ['zhiliang'].join('\n')
          }
          op.series[0].label = _label;
          // console.log(op)
          this.myChart.setOption(op,true)
      })
      /******************* 地图 **********************/
      this.myEchart = echarts.init(this.$refs.myEchart)
      this.option1 = {
        tooltip: {
          show: false
        },
        geo: {
          map: "china",
          roam: false, // 一定要关闭拖拽
          zoom: 1.23,
          center: [105, 36], // 调整地图位置
          label: {
            normal: {
              show: false, //关闭省份名展示
              fontSize: "10",
              color: "rgba(0,0,0,0.7)"
            },
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#DDF1FF",
              borderColor: "#AAD1EC",
              borderWidth: 1, //设置外层边框
              shadowBlur: 5,
              shadowOffsetY: 8,
              shadowOffsetX: 0,
              shadowColor: "#68C1FF"
            },
            emphasis: {
              areaColor: "#DDF1FF",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 5,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        },
        series: [{
          type: "map",
          map: "china",
          roam: false,
          zoom: 1.23,
          center: [105, 36],
          // geoIndex: 1,
          // aspectScale: 0.75, //长宽比
          showLegendSymbol: false, // 存在legend时显示
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false,
              textStyle: {
                color: "#fff"
              }
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#0d0059",
              borderColor: "#389dff",
              borderWidth: 0.5
            },
            emphasis: {
              areaColor: "#17008d",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 5,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };
      this.myEchart.setOption(this.option1)
      // console.log(this.dealWithData())
      // var dataValue = this.dealWithData(); //小点
      // var dataValue = this.smalltip; //小点
      // var data1 = dataValue.splice(0, 6); //大点

      this.myEchart.setOption(this.option2);
    }
  }
</script>

<style>
  .isdown {
    color: #66DE5E !important;
  }

  .isup {
    color: #FF5F5F !important;
  }

  #statistics {
    height: 100%;
  }

  #statistics #top p {
    /* height: 20px; */
    text-align: left;
  }

  #statistics #top p.p1,
  #statistics #bottom p.p1 {
    color: #333333;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 8px;
    text-align: left;
  }

  #statistics #top p.p2 {
    color: #ACAEBB;
    font-size: 14px;
  }

  #statistics #top p.p3 {
    font-size: 24px;
    color: #333333;
    padding-left: 14px;
  }

  #statistics #top .tip {
    padding: 16px;
    /* width: 222px; */
    flex-basis: 30%;
    height: 101px;
    background-color: #FFFFFF;
    margin-right: 24px;
    box-sizing: border-box;
  }

  #statistics #bottom .span_ {
    color: #ACAEBB;
    font-size: 14px;
  }

  #statistics #bottom .span_up {
    color: #FF5F5F;
  }

  #statistics #bottom .span_down {
    color: #66DE5E;
  }

  .yuan {
    background-color: #1BADE8;
    width: 6px;
    height: 6px;
    border-color: #1BADE8;
    border-radius: 50%;
    margin-right: 8px;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/statistics.vue